export default __webpack_public_path__ + "static/media/alert-warning-variation.0fb701e2.svg";